import { invalidate, useQueryClient } from "@msuite/ui/query";
import type { Tables } from "@msuite/utils/types";
import { RemoteFileInspector } from "@/components/files";

/** Props Interface */
interface TicketCardFilesProps {
	ticketId: string;
	projectId: string;
	ticketFiles: (Tables<"ticketFiles"> & {
		file: Tables<"files">;
	})[];
}

export function TicketCardFiles({ ticketId, projectId, ticketFiles }: TicketCardFilesProps) {
	/** Hooks */
	const qc = useQueryClient();

	/** Functions */
	async function handleOnFilesChanged() {
		await qc.invalidateQueries({ predicate: invalidate(["tickets", ticketId, projectId]) });
	}

	/** Render */
	return (
		<RemoteFileInspector
			size="xs"
			itemFiles={ticketFiles}
			tableName="ticketFiles"
			foreignKey="ticketId"
			identifier={ticketId}
			additionalForeignKeyValues={{ projectId }}
			projectId={projectId}
			parent={{ ticket: { id: ticketId, projectId } }}
			withUpload
			onInteraction={handleOnFilesChanged}
			onUnlinked={handleOnFilesChanged}
			onLinked={handleOnFilesChanged}
			showEmpty={false}
		/>
	);
}
